import React from "react";

function EditProduct(props) {
  return <div className="py-5">Test page WIP</div>;
}

export default EditProduct;
